import { v4 as uuid } from 'uuid';
import * as moment from 'moment';


export default class Utils {

  static blobToString(blob: any) {
    let u, x;
    u = URL.createObjectURL(blob);
    x = new XMLHttpRequest();
    x.open('GET', u, false);
    x.send();
    URL.revokeObjectURL(u);
    return x.responseText;
  }
  static lerArquivoTxt(arquivo) {
    return new Promise((resolve, reject) => {
      if (arquivo !== undefined) {
        const fileReader = new FileReader();
        fileReader.onload = function (e) {
          const txt = e.target['result'];
          resolve(txt);
        };
        fileReader.readAsText(arquivo);
      } else {
        reject('Arquivo não é valido');
      }
    });
  }
  static b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  static findAndReplace(string, target, replacement) {
    const length = string.length;
    let i = 0;
    for (i; i < length; i++) {
      string = string.replace(target, replacement);
    }
    return string;
  }

  static decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }


  static getDataCorrente() {
    return moment(new Date()).format('DD/MM/YYYY');
  }

  static getAnoCorrente() {
    return moment(new Date()).format('YYYY');
  }

  static getHoraCorrente() {
    return moment(new Date()).format('hh:mm:ss');
  }

  static getFormatoDDMMYYYHHMMSS() {
    return moment(new Date()).format('DDMMYYYY') + moment(new Date()).format('HHmm');
  }
  static getUuid() {
    return uuid();
  }

  static formatarCompetencia(competencia) {
    return moment(competencia.concat('01')).format('MMYYYY');
  }

  static convertetoDate(timeStamp: any): string {
    const data = new Date(timeStamp);
    return data.toLocaleDateString('pt-BR');
  }
  static convertetoHours(timeStamp: any): string {
    const data = new Date(timeStamp);
    return data.toLocaleTimeString().toString();
  }

  static retirarTipoInscricaoCNPJ(inscricao) {
    return inscricao.toString().length === 15 ? inscricao.toString().substring(1, (inscricao.toString().length)) : inscricao;
  }

  static formatarInscricao(inscricao, tipo) {
    tipo = tipo === null || tipo === undefined ? (inscricao.toString().substring(0, 1)) : tipo;
    const tamanho = inscricao.toString().length;
    let inscr = inscricao;
    let posicao;
    switch (tipo) {
      case '2':
        if (!this.tamanhoQuinze(tamanho, 12)) {
          posicao = tamanho - 12;
          inscr = inscricao.toString().substring(posicao, tamanho);
        }
        break;
      case '1':
        if (!this.tamanhoQuinze(tamanho, 14)) {
          posicao = tamanho - 14;
          inscr = inscricao.toString().substring(posicao, tamanho);
        }
        if (tamanho == 14) {
          inscr = inscricao.toString().substring(posicao, tamanho);
        }
        break;
      case '3':
        if (!this.tamanhoQuinze(tamanho, 11)) {
          posicao = tamanho - 11;
          inscr = inscricao.toString().substring(posicao, tamanho);
        }
        break;
      default:
        if (this.tamanhoQuinze(tamanho, 11)) {
          inscr = inscricao.toString().substring(3, tamanho);
        }
        break;
    }
    return inscr;
  }

  static tamanhoQuinze(tamanho, tamanhoReal): boolean {
    return tamanho === tamanhoReal;
  }

  static isEmpty(val) {
    return (val === undefined || val == null || val.length <= 0) ? true : false;
  }

  static stringToDate(data, format) {
    return moment(data).format(format).toString();
  }

  static formatReal(valor) {
    var tmp = valor + '';
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
    if (tmp.length > 8)
      tmp = tmp.replace(/([0-9]{1})([0-9]{3})([0-9]{3}),([0-9]{2})$/g, '$1.$2.$3,$4');

    else if (tmp.length > 6)
      tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

    return tmp;

  }

  static validaCei(valor) {

    var cNumero = valor.substring(0, 11);
    var nDv = valor.substring(11, 12);
    var nSoma = 0;
    var cMat = " ";
    var matriz = "74185216374";
    var nTam = 0;
    var nDvCalc = 0;

    for (var i = 0; i <= 10; i++) {
      nSoma = nSoma + (cNumero.substring(i, i + 1) * parseInt(matriz.substring(i, i + 1)));
    }
    var nSoma1 = nSoma + "";
    nTam = nSoma1.length;
    var nAux = (parseInt(nSoma1.substring(0, nTam - 1)) * 1) + (parseInt(nSoma1.substring(nTam - 1, nTam)) * 1);
    var nAux1 = nAux + "";
    nTam = nAux1.length;
    if (nTam == 1) {
      var nUnidade = nAux1.substring(0, 1);
    }
    else {
      var nUnidade = nAux1.substring(1, 2);
    }

    nDvCalc = 10 - (parseInt(nUnidade) * 1);
    if (nDvCalc > 9) {
      nDvCalc = 0;
    }

    if (nDvCalc == nDv) {
      return true;
    }
    else {
      return false;
    }

  }

  static mascararInscricao(tpInscricao: string, inscricao): string {
    switch (tpInscricao) {
      case '1':
        return Utils.mascararCNPJ(inscricao + '');
      case '2':
        return Utils.mascararCEI(inscricao + '');
      case '3':
        return Utils.mascararCPF(inscricao + '');
    }
  }

  static mascararCNPJ(nu_cnpj) {
    //'00.000.000/0000-00'
    nu_cnpj = this.inscricaoformatada(nu_cnpj, 15);   
    return nu_cnpj.substring(1, 3) + "." + nu_cnpj.substring(3, 6) + "." + nu_cnpj.substring(6, 9) + "/" + nu_cnpj.substring(9, 13) + "-" + nu_cnpj.substring(13, 15);
  }

  static mascararCPF(nu_cpf) {

    nu_cpf = this.inscricaoformatada(nu_cpf, 15);

    if(nu_cpf.length == 15){
      nu_cpf = nu_cpf.substring(4, 15);
    }
    return nu_cpf.substring(0, 3) + "." + nu_cpf.substring(3, 6) + "." + nu_cpf.substring(6, 9) + "-" + nu_cpf.substring(9, 11);
  }

  static mascararCEI(nu_cei: string) {
    nu_cei = this.inscricaoformatada(nu_cei, 15);
    return nu_cei.substring(3, 5) + "." + nu_cei.substring(5, 8) + "." + nu_cei.substring(8, 13) + "-" + nu_cei.substring(13, 15);
  }

  static inscricaoformatada(inscricao, tamanho){   
    while (inscricao.length < tamanho) {
      inscricao = "0" + inscricao;
    }
    return inscricao;
  }

  static unmaskInscricao(val: string) {
    return val.replace(/\D/g, '');
  }

  static inscricaoQuinzeDigitos(inscricao: string, tipoInscricao: string): string {
    
    if(inscricao.length === 15){
      return inscricao;
    }

    let inscr = Utils.unmaskInscricao(inscricao);

    while(inscr.length < 14) {
      inscr = '0'.concat(inscr);
    }
    
    return tipoInscricao.concat(inscr);
  }

static trataErro(status){

  switch (status) {
    case 401:
      return 'Problema de conexão ou autorização de acesso ao servidor.' + status;
    case 0:
    case 404:
      return 'Sistema indisponível no momento, favor tentar mais tarde. (N001)'
    default:
      return 'Problema de conexão com o banco de dados. ' + status;  
  }
}

}
